<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header" [afTranslate]="'results-report.export-results-report'">Exportar resultados de la encuesta</span>
  </div>
   @if(exportResultReport.exportFieldsOpen){
    <!-- Contenedor -->
    <div class="common-modal__content-scroll">
      <div class="common-modal__form-container">
        <field-type-list-extended
          [field]="exportResultReport.fieldsExports"
          [preSelectItem]="exportResultReport.addFields"
          [listValues]="exportResultReport.exportFieldsList"
          (itemSelected)="itemSelected($event, 'addFields')">
        </field-type-list-extended>
      </div>
    </div>
    <!-- Footer botonera -->
    <div class="common-modal__footer">
      <button class="common-button__text-border"
        (click)="cancelSelectionFields()">
        <span class="common-button__text-title"
          [afTranslate]="'export-result-report.cancel-selection'">_Cancelar Selección</span>
      </button>
      <button class="common-button__text"
        (click)="addSelectionFields()">
        <span class="common-button__text-title"
          [afTranslate]="'export-result-report.add-selection'">_Añadir Selección</span>
      </button>
    </div>
   }@else{
    <!-- Contenedor -->
    <div class="common-modal__content">
      <div class="common-modal__form-container">
        <div class="common-container__mandatory-obligatory-message-form">
          <span class="common-tag__mandatory-text-asterisk">*</span>
          <span class="common-tag__mandatory-label-text-obligatory-message"
            [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
        </div>
        <field-type-text-simple [field]="exportResultReport.nameDocument"
          [preSelectItem]="exportResultReport.name"
          (itemSelected)="itemSelected($event, 'name')">
        </field-type-text-simple>
        <div class="export-result-report__container-switch">
          <field-type-switch [field]="{label: 'export-result-report.export-field-selection' | afTranslate}"
            [preSelectItem]="exportResultReport.exportFields"
            (itemSelected)="showExportReport($event.newValue)">
          </field-type-switch>
          @if (exportResultReport.listSelected?.length) {
            <div class="export-result-report__container-selected-fields">
              <div class="common-badge__badge-block">
                <span class="common-badge__square-md">{{exportResultReport.listSelected?.length}}</span>
              </div>
              <span class="export-result-report__text-selected-fields"
                [afTranslate]="exportResultReport.listSelected?.length === 1?'common.field':'common.fields'">_Campos</span>
              <button class="common-button__icon-md-noborder"
                (click)="exportResultReport.exportFieldsOpen = true">
                <i class="lf-icon-editable-form common-icon__md"></i>
              </button>
            </div>
          }
        </div>
      </div>
    </div>
    <!-- Footer botonera -->
    <div class="common-modal__footer">
      <button class="common-button__text-border"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">_Cancelar</span>
      </button>
      <button class="common-button__text"
        (click)="exportPoll()">
        <span class="common-button__text-title"
          [afTranslate]="'common.export'">_Exportar</span>
      </button>
    </div>
  }
</div>
